import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class TimelineLine extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        isActive: PropTypes.bool,
        title: PropTypes.string,
        subtitle: PropTypes.string,
    };

    /**
     * Default props
     */
    static defaultProps: {
        isActive: false,
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render () {
        const { title, subtitle, isActive }  = this.props;

        const classes = cx({
            'submission-status-timeline-line': true,
            'submission-status-timeline-line-active': isActive,
        });

        return (
            <li className={classes}>
                <div className="submission-status-description">
                    { title && (<p>{title}</p>)}
                    { subtitle && (<p className="submission-status-limit">{subtitle}</p>)}
                </div>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Timeline/TimelineLine.jsx